<template>
  <dialog :open="isOpen" class="default-dialog">
    <div class="dialog-content">
      <header class="dialog-header">
        <div>
          <h2 class="dialog-title text-warning d-flex align-items-center">
            <i class="material-icons me-2">warning</i>
            {{ title }}
          </h2>
        </div>
        <button @click="closeModal" class="close-icon-button">✖</button>
      </header>

      <main class="dialog-body">
        <p class="text-sm font-weight-bold text-dark mb-3" style="line-height: 1.5;">
          Como você utiliza a <strong>Carteira do Sistema</strong>, suas campanhas são criadas gratuitamente.
        </p>
        <p class="text-sm text-secondary" style="line-height: 1.5;">
          Para mantermos nossa infraestrutura rápida e evitar sobrecarga de dados desnecessários, 
          toda campanha que for criada e <strong>permanecer vazia (sem nenhum participante) por mais de 7 dias úteis</strong> 
          será automaticamente excluída do sistema.
        </p>
        <p class="text-sm text-secondary font-weight-bold mt-4 text-center">
          Mantenha sua campanha movimentada para não perdê-la!
        </p>

        <div class="text-center mt-4">
          <button class="btn bg-gradient-warning mb-0 px-5" @click.prevent="closeModal">
            Ciente, continuar
          </button>
        </div>
      </main>
    </div>
  </dialog>
</template>

<script>
export default {
  props: {
    isOpen: Boolean,
  },
  data() {
    return {
      title: 'Aviso Importante!',
    };
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.default-dialog {
  border: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999999;
  background: none;
  backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, 0.4);
  width: 100vw;
  height: 100vh;
}

dialog {
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s, transform 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
}

dialog[open] {
  opacity: 1;
  pointer-events: inherit;
}

dialog::backdrop {
  backdrop-filter: blur(2px);
  animation: fadein 0.2s linear;
}

.dialog-content {
  width: 90%;
  max-height: 90%;
  overflow: auto;
  max-width: 500px;
  background: white;
  border-radius: 12px;
  padding: 24px;
  z-index: 2;
  transform: scale(0.96);
  transition: transform 0.2s;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

dialog[open] .dialog-content {
  transform: scale(1);
}

.dialog-title {
  font-family: inherit;
  font-size: 22px;
  margin: 0;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10px;
}

.dialog-body {
  margin: 10px 0 0 0;
}

.close-icon-button {
  background: none;
  border: none;
  font-size: 20px;
  color: #555;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.close-icon-button:hover {
  color: #000;
}
</style>
